<ng-content select="fsn-big-tab"></ng-content>
<ng-content select="fsn-databox"></ng-content>
